import React, { useState } from 'react';

const RegisterPage = ({ handleRegister, mode, setBtnToggle, errMsg }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [username, setUsername] = useState('')

    const handleSubmit = (e) => {
        e.preventDefault();
        handleRegister(username, email, password);
    };

    return (
        <div className="flex justify-center items-center h-screen">
            <div className="w-full max-w-xs lg:max-w-md">
                <form onSubmit={handleSubmit} className={`${mode==='night'?"bg-gray-700":"bg-gray-300"} shadow-md rounded px-8 pt-6 pb-8 mb-4`}>
                    <h2 className={`mb-4 text-xl font-bold ${mode === 'night' ? " text-gray-300" : "text-gray-700"}`}>Register</h2>
                    <div className="mb-4">
                        <label className={`block ${mode === 'night' ? "text-gray-300" : "text-gray-700"} text-sm font-bold mb-2`} htmlFor="username">
                            Username
                        </label>
                        <input
                            type="name"
                            id="username"
                            placeholder="Username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        />
                    </div>
                    <div className="mb-4">
                        <label className={`block ${mode === 'night' ? "text-gray-300" : "text-gray-700"} text-sm font-bold mb-2`} htmlFor="email">
                            Email
                        </label>
                        <input
                            type="email"
                            id="email"
                            placeholder="Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        />
                    </div>
                    <div className="mb-6">
                        <label className={`block ${mode === 'night' ? "text-gray-300" : "text-gray-700"} text-sm font-bold mb-2`} htmlFor="password">
                            Password
                        </label>
                        <input
                            type="password"
                            id="password"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        />
                    </div>
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                    >
                        Register
                    </button>
                    <p className={`${mode === 'night' ? "text-gray-300" : "text-gray-700"}`}>Existing User? <span className='text-blue-500 cursor-pointer' onClick={() => setBtnToggle('login')}>Login</span></p>
                    <p className='text-[#c34444]'>{errMsg}</p>
                </form>
            </div>
        </div>
    );
};

export default RegisterPage;
